import { InjectionToken } from '@angular/core';
import { ImagePreviewData } from './image-preview-overlay.service';
export const IMAGE_PREVIEW_DIALOG_DATA = new InjectionToken<ImagePreviewData>(
    'IMAGE_PREVIEW_DIALOG_DATA',
);
